export default __webpack_public_path__ + "static/media/ee5.222857d0.png";